<wdm-header-root></wdm-header-root>

<wdm-list-workflow-table *ngIf="viewListWorkFlow"></wdm-list-workflow-table>

<router-outlet></router-outlet>
